<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>物料源</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="queryParams.code" placeholder="请输入代码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item" v-if="postList.quality_assurance_code">
                <el-input
                    v-model="queryParams.quality_assurance_code"
                    placeholder="请输入QA代码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>

            <div class="main_header_item" v-if="postList.edition_code">
                <el-input
                    v-model="queryParams.edition_code"
                    placeholder="请输入版本代码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.quality_standard">
                <el-input
                    v-model="queryParams.quality_standard"
                    placeholder="请输入质量标准"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.material_rid">
                <vDropdown
                    model_key="material_rid"
                    model_name="请选择物料"
                    :model_value_default="queryParams['material_rid']"
                    request_uri="materials"
                    @onDropChange="onDropChange"
                    ref="material_rid_ref"
                ></vDropdown>
            </div>

            <div class="main_header_item" v-if="postList.manufacturer_rid">
                <vSearchSelect
                    model_key="manufacturer_rid"
                    model_name="请输入生产企业搜索"
                    request_uri="searchAccounts"
                    default_option_key="manufacturer_option"
                    :default_option="queryParams['manufacturer_option']"
                    @onDropChange="onDropChange"
                    ref="manufacturer_rid_ref"
                ></vSearchSelect>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" v-if="postList.addBtn">新增</el-button>
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(2)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="material_source" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="material_source"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div v-if="in_array(item.prop, ['code', 'name', 'material_name', 'manufacturer_name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>

                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>

                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize, onSearch, in_array, onDelete } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload,
        vSearchSelect
    },
    name: 'materialSourceComponent',
    data() {
        return {
            draggable: {
                data_name: 'material_source'
            },
            down_loading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {}
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('pageAndSerachSelect');
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                // 填入相应的参数，调用getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        toDetail(row, prop) {
            if (in_array(prop, ['code', 'name'])) {
                this.$router.push({
                    path: '/materialSourceDetail',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'material_name' && row.material_rid != '') {
                this.$router.push({
                    path: '/materialDetail',
                    query: {
                        id: row.material_rid
                    }
                });
            } else if (prop == 'manufacturer_name' && row.manufacturer_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.manufacturer_rid
                    }
                });
            }
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                code: '',
                quality_assurance_code: '',
                edition_code: '',
                quality_standard: '',
                material_rid: '',
                manufacturer_rid: '',
                manufacturer_option: {} // 记忆下拉搜索用的，传到后台也没关系会自动过滤
            };
            this.saveQueryParams();
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('material_source_params', JSON.stringify(this.queryParams));
            }
        },
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('material_source_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                        this.queryParams.manufacturer_option = queryParams.manufacturer_option || {};
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('material_source', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).material_source;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'materialSourceLists');
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'materialSourceDelete', row.code);
        },
        //编辑
        update(rid) {
            this.$router.push({
                path: 'materialSourceEdit',
                query: {
                    type: 'update',
                    id: rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'materialSourceEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy(rid) {
            this.$router.push({
                path: 'materialSourceEdit',
                query: {
                    type: 'copy',
                    id: rid
                }
            });
        },
        reset() {
            this.initQueryParams();
            this.$refs.material_rid_ref && this.$refs.material_rid_ref.reset();
            this.$refs.manufacturer_rid_ref && this.$refs.manufacturer_rid_ref.reset();
            this.getList();
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>